import styled from "@emotion/styled"
import type { TextWeight } from "@porsche-design-system/components-react"
import { PIcon, PText } from "@porsche-design-system/components-react"
import { colorWarningFrosted, radius2Xl } from "@porsche-design-system/components-react/emotion"
import { Tooltip } from "../tooltip/Tooltip"

interface WarningProps {
	ellipsis?: boolean
	hint: string
	label: string
	weight?: TextWeight
}

export const Warning = ({ ellipsis, hint, label, weight, ...props }: WarningProps) => {
	return (
		<Tooltip appendToBody content={hint}>
			<CustomTag {...props}>
				<PIcon name="warning" size="xs" />
				<StyledText size="xs" weight={weight} ellipsis={ellipsis}>
					{label}
				</StyledText>
			</CustomTag>
		</Tooltip>
	)
}

// Unfortunately we have to rebuild PTag ourselves, since it does not support truncation/ellipsis.
// Using a nested PText with ellipsis does not work, as it requires a max-width that subtracts the space
// for the icon, e.g. `calc(100% - 22px)`. However, for this to work, the PTag needs to have `display: block`,
// leading to a full width (typical block element behavior) PTag, even when the label is shorter.
// https://github.com/porsche-design-system/porsche-design-system/blob/cc5b7ef91093e0a638ebf3d9fc99385852cc23ac/packages/components/src/components/tag/tag-styles.ts#L69
const CustomTag = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 2px;
    max-width: 100%;
    padding: 1px 6px;
    padding-inline-start: 4px;
    background: ${colorWarningFrosted};
    border-radius: ${radius2Xl};
    box-sizing: border-box;
    vertical-align: top;
`

const StyledText = styled(PText)`
	min-width: 0;
`
